import { useState } from 'react';

// `extra` adds more links inside a row; the row itself still opens `href`.
const PRESS = [
  { name: 'BILLBOARD',        href: 'https://www.billboard.com/lists/taylor-swift-2023-tour-artists-who-are-opening-for-her/',
    extra: [{ label: 'INSTAGRAM', href: 'https://www.instagram.com/p/DeIDLmOgXxE/' }] },
  { name: 'VARIETY',          href: 'https://variety.com/lists/varietys-power-of-young-hollywood-impact-report-2022/' },
  { name: 'CULT MTL',         href: 'https://cultmtl.com/wp-content/uploads/2026/05/Cult-MTL-Best-of-MTL-May-2026.pdf' },
  { name: 'MELODIC MAGAZINE', href: 'https://www.melodicmag.com/live-events/the-weeknd-mesmerizes-montreal-for-a-long-awaited-show/' },
];

const CLIENTS = [
  'JONAS BROTHERS', 'LIVE NATION WOMEN', 'JADE LEMAC', 'GRAE',
  'JESSIA', 'LIVE NATION CANADA', 'ATLANTIC RECORDS', 'TASH SULTANA',
  'NERIAH', 'GROUPLOVE', 'G FLIP', 'ELIJAH WOODS', 'TOVE LO',
  'XANA', 'UPSAHL', 'GAYLE', 'RISE AGAINST', 'AUSTIN MILLZ',
  'BOLDEN.', 'JIGITZ', 'WARNER MUSIC', 'RIGHTCALL MEDIA',
];

// Small links beside a press row's name. They open on their own, so the click must
// not also reach the row (which opens the article).
function ExtraLinks({ links = [], size = 9 }) {
  return links.map((l) => (
    <a
      key={l.href}
      href={l.href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="mono"
      style={{
        flexShrink: 0, textDecoration: 'none', whiteSpace: 'nowrap',
        fontSize: size, letterSpacing: '0.2em', color: 'var(--bone-50)',
        borderBottom: '1px solid var(--bone-30)', paddingBottom: 2,
      }}
    >
      {l.label} ↗
    </a>
  ));
}

export default function Press({ width = 1440, height = 900, isMobile = false }) {
  const [active, setActive] = useState(0);

  // ── Mobile layout ──────────────────────────────────────────────────────────
  if (isMobile) {
    return (
      <div style={{ width: '100%', height: '100%', background: 'var(--ink-2)', overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>
        <div style={{ padding: '56px 24px 40px' }}>
          {/* Header */}
          <div className="mono" style={{ color: 'var(--bone-50)', fontSize: 10, display: 'flex', gap: 12, alignItems: 'center', marginBottom: 28 }}>
            <span style={{ color: 'var(--red)' }}>06</span>
            <span style={{ width: 28, height: 1, background: 'var(--bone-30)', display: 'inline-block' }} />
            PRESS & CLIENTS
          </div>

          {/* Press quotes */}
          <div className="mono" style={{ color: 'var(--bone-50)', fontSize: 9, letterSpacing: '0.25em', marginBottom: 14 }}>PRESS</div>
          <div style={{ marginBottom: 32 }}>
            {PRESS.map((p, i) => (
              <div
                key={i}
                onClick={() => window.open(p.href, '_blank', 'noopener,noreferrer')}
                style={{
                  padding: '14px 0',
                  borderBottom: '1px solid var(--bone-15)',
                  borderTop: i === 0 ? '1px solid var(--bone-15)' : 'none',
                  cursor: 'pointer',
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                }}
              >
                <div style={{
                  fontFamily: 'var(--font-display)', fontWeight: 800,
                  fontSize: 24, color: 'var(--bone)',
                  letterSpacing: '-0.02em', textTransform: 'uppercase', lineHeight: 1,
                }}>{p.name}</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexShrink: 0 }}>
                  <ExtraLinks links={p.extra} size={8} />
                  <div className="mono" style={{ color: 'var(--red)', fontSize: 9, letterSpacing: '0.18em' }}>→</div>
                </div>
              </div>
            ))}
          </div>

          {/* Divider */}
          <div style={{ height: 1, background: 'var(--bone-15)', marginBottom: 24 }} />

          {/* Clients */}
          <div className="mono" style={{ color: 'var(--bone-50)', fontSize: 9, letterSpacing: '0.25em', marginBottom: 14 }}>CLIENTS & COLLABORATORS</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0 }}>
            {CLIENTS.map((c, i) => (
              <div key={i} style={{
                padding: '8px 0',
                borderBottom: '1px solid var(--bone-08)',
                borderRight: i % 2 === 0 ? '1px solid var(--bone-08)' : 'none',
                paddingRight: i % 2 === 0 ? 16 : 0,
                paddingLeft: i % 2 === 1 ? 16 : 0,
              }}>
                <div className="mono" style={{ color: 'var(--bone-dim)', fontSize: 10, letterSpacing: '0.02em' }}>{c}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ position: 'relative', width, height, background: 'var(--ink-2)', overflow: 'hidden' }}>
      <div style={{
        position: 'absolute', top: 40, left: 64, right: 64,
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 30,
      }}>
        <div className="mono" style={{ color: 'var(--bone-50)', display: 'flex', gap: 16 }}>
          <span style={{ color: 'var(--red)' }}>06</span>
          <span style={{ width: 40, height: 1, background: 'var(--bone-30)', marginTop: 6, display: 'inline-block' }} />
          PRESS & CLIENTS
        </div>
        <div className="mono" style={{ color: 'var(--bone-50)' }}>AS SEEN IN · WORKED WITH</div>
      </div>

      <div style={{
        position: 'absolute', top: 110, left: 64, right: 64, bottom: 100,
        display: 'grid', gridTemplateColumns: '1fr 1px 1fr', zIndex: 20,
      }}>
        <div style={{ paddingRight: 48, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div className="mono" style={{ color: 'var(--bone-50)', marginBottom: 20, fontSize: 10, letterSpacing: '0.25em' }}>PRESS</div>
          {PRESS.map((p, i) => (
            <div
              key={i}
              onMouseEnter={() => setActive(i)}
              onMouseLeave={() => setActive(0)}
              onClick={() => window.open(p.href, '_blank', 'noopener,noreferrer')}
              style={{
                display: 'flex', alignItems: 'center', gap: 20,
                padding: '10px 0',
                borderTop: i === 0 ? '1px solid var(--bone-15)' : 'none',
                borderBottom: '1px solid var(--bone-15)',
                cursor: 'pointer',
              }}
            >
              <div className="mono" style={{ color: active === i ? 'var(--red)' : 'var(--bone-30)', width: 32, fontSize: 10, transition: 'color 300ms', flexShrink: 0 }}>
                {String(i + 1).padStart(2, '0')}
              </div>
              <div style={{
                fontFamily: active === i ? 'var(--font-serif)' : 'var(--font-display)',
                fontStyle:  active === i ? 'italic' : 'normal',
                fontWeight: active === i ? 400 : 900,
                fontSize:   active === i ? '6.5vw' : '4.5vw',
                color: active === i ? 'var(--bone)' : 'var(--bone-50)',
                letterSpacing: active === i ? '-0.01em' : '-0.03em',
                flex: 1,
                transition: 'all 400ms var(--ease-out-cine)',
                textTransform: 'uppercase',
                lineHeight: 1.05,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}>{p.name}</div>
              <ExtraLinks links={p.extra} />
              <div className="mono" style={{
                color: 'var(--red)',
                opacity: active === i ? 1 : 0,
                transform: active === i ? 'translateX(0)' : 'translateX(12px)',
                transition: 'all 400ms var(--ease-out-cine)',
                fontSize: 9, letterSpacing: '0.22em', flexShrink: 0,
              }}>READ ARTICLE →</div>
            </div>
          ))}
        </div>

        <div style={{ background: 'var(--bone-15)', width: 1 }} />

        <div style={{ paddingLeft: 48, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div className="mono" style={{ color: 'var(--bone-50)', marginBottom: 20, fontSize: 10, letterSpacing: '0.25em' }}>CLIENTS & COLLABORATORS</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0 }}>
            {CLIENTS.map((c, i) => (
              <div key={i} style={{
                padding: '10px 0',
                borderBottom: '1px solid var(--bone-08)',
                borderRight: i % 2 === 0 ? '1px solid var(--bone-08)' : 'none',
                paddingRight: i % 2 === 0 ? 24 : 0,
                paddingLeft: i % 2 === 1 ? 24 : 0,
              }}>
                <div className="mono" style={{ color: 'var(--bone-dim)', fontSize: 13, letterSpacing: '0.03em' }}>{c}</div>
              </div>
            ))}
          </div>
          <div className="mono" style={{ color: 'var(--bone-30)', fontSize: 10, marginTop: 28, lineHeight: 1.7 }}>
            RECORD LABELS · MANAGEMENT · LIVE EVENTS<br />
            DIGITAL CAMPAIGNS · EDITORIAL · TOURING
          </div>
        </div>
      </div>

      <div style={{ position: 'absolute', bottom: 32, left: 64, right: 64, display: 'flex', justifyContent: 'space-between', zIndex: 20 }}>
        <div className="mono" style={{ color: 'var(--bone-30)' }}>[ 06 / 08 ]</div>
        <div className="mono" style={{ color: 'var(--bone-30)' }}>↓ STORE</div>
      </div>

      <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', background: 'radial-gradient(ellipse at center, transparent 40%, rgba(0,0,0,0.55) 100%)' }} />
    </div>
  );
}
